import React from 'react'
import ProjectSharesOld from '../ProjectSharesOld'
import ProjectShares, { ProjectSharesProps } from './ProjectShares'
import { useFlag } from '@sketch/modules-common'

export default function ProjectSharesSwitch(props: ProjectSharesProps) {
  const isNestedProjectsOn = useFlag('nested-projects')

  return isNestedProjectsOn ? (
    <ProjectShares {...props} />
  ) : (
    <ProjectSharesOld {...props} />
  )
}
